import { Link } from "react-router-dom";
import { Leaf, Twitter, Linkedin, Facebook } from "lucide-react";

const FOOTER_LINKS = [
  { label: "About Us", to: "/about-us", testId: "footer-about-us-link" },
  { label: "Pricing", to: "/#pricing", testId: "footer-pricing-link" },
  { label: "Legal", to: "/legal", testId: "footer-legal-link" },
  { label: "Contact Us", to: "/contact-us", testId: "footer-contact-us-link" },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-slate-200 bg-slate-900 py-12 text-slate-300" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
          <Link to="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal-600 text-white">
              <Leaf className="h-4 w-4" />
            </div>
            <span className="font-semibold text-white">RootLyst</span>
          </Link>
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            {FOOTER_LINKS.map((l) => (
              <Link key={l.label} to={l.to} data-testid={l.testId} className="hover:text-white">
                {l.label}
              </Link>
            ))}
          </div>
          <div className="flex gap-4">
            <Twitter className="h-4 w-4 hover:text-white" />
            <Linkedin className="h-4 w-4 hover:text-white" />
            <Facebook className="h-4 w-4 hover:text-white" />
          </div>
        </div>
        <p className="mt-8 text-center text-xs text-slate-500">© {new Date().getFullYear()} RootLyst. All rights reserved. · contact@rootlyst.com</p>
      </div>
    </footer>
  );
}
